module.exports = require('./lib/schema-inspector');



//////////////////
// WEBPACK FOOTER
// ./~/schema-inspector/index.js
// module id = 1702
// module chunks = 1